import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { formatDate, timeAgo } from "../utils/format.ts";

interface RelativeTimeProps {
  value: string | null | undefined;
  /** Shown, greyed out, when there is no time ("Never", "Not yet"). */
  never?: string;
}

/**
 * When something last happened ("3h ago"), with the full date on hover. For
 * activity (last seen, last synced, updated); a record's own dates (filed,
 * deadline) stay absolute with `FormattedDate`.
 */
export default function RelativeTime({ value, never = "Never" }: RelativeTimeProps) {
  if (!value) {
    return (
      <Typography variant="inherit" component="span" sx={{ color: "text.disabled" }}>
        {never}
      </Typography>
    );
  }
  return (
    <Tooltip title={formatDate(value, "full")}>
      <span>{timeAgo(value)}</span>
    </Tooltip>
  );
}
